// extracted by mini-css-extract-plugin
export default {"large":"loader_large__g3JJY","loader":"loader_loader__Otage","load8":"loader_load8__n-HCz","small":"loader_small__MBWly"};